import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { Form, Button, Table, InputGroup, Badge, Accordion, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import LoaderOverlay from "../Components/shared/Loader";

function MyExpenseRequestPage() {
    const hierarchy = sessionStorage.getItem('role');
    const [request, setRequest] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchRequest();
    }, []);

    const fetchRequest = async () => {
        try {
            debugger;
            setIsLoading(true);
            const response = await adminInstance.get(`expenserequest/Get`);            
            setRequest(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
            setIsLoading(false);
        }
    };

    const navigate = useNavigate();

    const handleView = (reqId) => {
        var urlName = "MyExpenseRequestDetail";
        navigate(`/${urlName}/${reqId}`);
    }

    const filteredData = data
        .filter(spare =>
            spare.EMP_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            spare.TRAVEL_TYPE?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Get distinct tripName, tripId, and status from filteredData
    const trips = Array.from(
        filteredData.reduce((map, item) => {
            if (item.TRIP_ID && !map.has(item.TRIP_ID)) {
                map.set(item.TRIP_ID, {
                    tripId: item.TRIP_ID,
                    tripName: item.TRIP_NAME,
                    status: item.TRIP_STATUS,
                    tripDate: item.TRIP_DATE, // optional, if you want to show created date
                    requests: []
                });
            }
            return map;
        }, new Map()).values()
    );
    const onSubmitTrip = async (tripId) => {
        debugger;
        const response = await adminInstance.put(`trip/SubmitTrip/` + tripId);
        if (response.status === 200) {
            alert("Trip submitted successfully");
            fetchRequest();
        } else {
            alert("Failed to submit trip");
        }
    }

    const getBadgeVariant = (status) => {
        switch (status) {
            case "Open":
                return "warning";
            case "Submitted":
                return "info";
            case "Approved":
            case "Completed":
            case "Closed":
                return "success";
            case "Cancelled":
            case "Rejected":
                return "danger";
            default:
                return "secondary";
        }
    };

    const getTotalAmount = (requests) =>
        requests.reduce((sum, req) => sum + (req.TOTAL_AMT || 0), 0);

    return (
        <>
            <LoaderOverlay loading={isLoading} message="Loading" height="500px" />
            <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4>
                                My Reimbursement
                            </h4>
                            <Button
                                variant="primary"
                                onClick={() => navigate('/NewExpenseRequest')}
                            >
                                New Request
                            </Button>
                        </div>
                    </div>
                    <div className="card-body aon-card-body">
                        {false &&
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Date</th>
                                                <th>Travel Date</th>
                                                <th>Employee</th>
                                                <th>Travel Type</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr >
                                                <td colSpan={8}>
                                                    <InputGroup className="mb-3">
                                                        <Form.Control
                                                            placeholder="Search request..."
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ID}</td>
                                                            <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{new Date(emp.TRAVEL_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{emp.EMP_NAME}</td>
                                                            <td>{emp.TRAVEL_TYPE}</td>
                                                            <td>{emp.TOTAL_AMT}</td>
                                                            <td>{emp.REQ_STATUS}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleView(emp.ID)} style={{ marginRight: 20 }}>View</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                    <Accordion defaultActiveKey="0">
                        {trips.map((trip, index) => (
                            <Card key={trip.tripId} className="mb-2">
                                <Accordion.Item eventKey={index.toString()}>
                                    <Accordion.Header>
                                        <div className="w-100 d-flex justify-content-between align-items-center">
                                            <div>
                                                <div className="fw-bold">
                                                    #{trip.tripId} — {trip.tripName}
                                                </div>
                                                <div className="text-muted small">
                                                    Created: {new Date(trip.tripDate).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    })}
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <Badge bg={getBadgeVariant(trip.status)} className="me-3 px-3 py-2">
                                                    {trip.status}
                                                </Badge>

                                                <div className="me-3 fw-semibold text-success">
                                                    ₹{getTotalAmount(filteredData?.filter(s => s.TRIP_ID === trip.tripId && (s.REQ_STATUS === "Draft" || s.REQ_STATUS === "Open" || s.REQ_STATUS === "Approved"))).toFixed(2)}
                                                </div>

                                                {trip.status === "Open" && (
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            onSubmitTrip(trip.tripId);
                                                        }}
                                                    >
                                                         Submit
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        {filteredData?.filter(s => s.TRIP_ID === trip.tripId).length > 0 ? (
                                            <Table striped bordered hover responsive size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>Id</th>
                                                        <th>Date</th>
                                                        <th>Travel Date</th>
                                                        <th>Employee</th>
                                                        <th>Travel Type</th>
                                                        <th>Amount</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredData?.filter(s => s.TRIP_ID === trip.tripId)?.map((emp, idx) => (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ID}</td>
                                                            <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{new Date(emp.TRAVEL_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{emp.EMP_NAME}</td>
                                                            <td>{emp.TRAVEL_TYPE}</td>
                                                            <td>{emp.TOTAL_AMT}</td>
                                                            <td><Badge bg={getBadgeVariant(emp.REQ_STATUS)} className="me-2">
                                                                {emp.REQ_STATUS}
                                                            </Badge></td>
                                                            <td>
                                                                <Button variant="outline-primary" onClick={() => handleView(emp.ID)} style={{ marginRight: 20 }}>View</Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        ) : (
                                            <p className="text-muted">No requests added yet.</p>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Card>
                        ))}
                    </Accordion>
                    </div>
                </div>
            
        </>
    );
}

export default MyExpenseRequestPage;
